<template>

    <div class="About App-page" data-scroll-container>

        <div class="App-row logo">  
            <Logo/>  
        </div>  
        <div class="App-row about end">   
            <div class="App-sub about">
                <div ref="title" class="App-title">{{ trans('About.title') }}</div>
                <div ref="b1" class="App-desc" v-html="trans('About.desc')"/>  
                <div class="App-space very-small" />    
            </div>       
        </div>  
        <div class="App-row start end">  
            <div class="App-sub">
                <Button/>
            </div>
        </div>  
        <Footer/>
    </div>

</template>

<script>

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

import Logo from "@/components/assets/svg/Logo"
import Footer from "@/components/assets/Footer"
import Button from "@/components/assets/Button"
import LocomotiveScroll from 'locomotive-scroll'

export default {

    name: 'Home',
    components: { Logo, Footer, Button },   
    computed: {
        locked() { return this.$store.getters['commons/header_locked'] },
        tint() { return this.$store.getters['commons/tint'] }
    },

    watch: {
        locked(nw) {

            // console.log('xxxxx');

            // if(this.$root.isPhone)
            //     return

            // if(nw)
            //     this.showArrow()
            // else 
            //     this.hideArrow()
        },
    },
    beforeDestroy() {
        gsap.set(".App-container", { scrollTo: { y: 0, autoKill: true }}) 
        let triggers = ScrollTrigger.getAll()
            triggers.forEach( trigger => {          
                trigger.kill()
            })
        if(this.$scroll)
            this.$scroll.destroy()
    },

    mounted() {

        this.$nextTick(()=>{

            if(!this.$root.isPhone)
                this.$scroll = new LocomotiveScroll({
                    el: document.querySelector('[data-scroll-container]'),
                    smooth: true
                })

             gsap.timeline({ delay: 3.25 })
                .from([this.$refs.title, this.$refs.b1 ], { duration: .35, y: 50, ease: 'cubic.out', stagger: .15, opacity: 0 })


        })   
    },

    methods: {
        // getTint() {
        //     return this.tint
        // },
        // onClick() {
        //     const target =  document.querySelector('.Phone')
        //     const offsetY = ((window.innerHeight - Math.ceil(target.getBoundingClientRect().height))/2)+32
        //     gsap.to(".App-container", { scrollTo: { y: target, offsetY: offsetY, autoKill: true }, duration: .75, ease: 'cubic.out'}) 
        // },
        // hideArrow() {
        //     gsap.to(['.App-arrow'], { duration: .5, y: -50, ease: 'cubic.out', opacity: 0 })
        // },
        // showArrow() {
        //     gsap.to(['.App-arrow'], { duration: .5, y: 0, ease: 'cubic.out', opacity: 1, delay: .5 })
        // },
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Home
    position relative

</style>


